import { render, staticRenderFns } from "./HierarchyItemMenuButton.vue?vue&type=template&id=66cac01c&"
import script from "./HierarchyItemMenuButton.vue?vue&type=script&lang=ts&"
export * from "./HierarchyItemMenuButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports